<template>
  <div class="has-logo" id="pageLeftSidebar">
    <logo :collapse="isCollapse"/>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path"/>
      </el-menu>
    </el-scrollbar>
    <div id="siderBarFooter" @click="toggleSideBar">
      <div id="siderBarFooterMain">
        <i class="el-icon-s-unfold"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import router from '@/router'

export default {
  components: {SidebarItem, Logo},
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const {meta, path} = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      routes: []
    }
  },
  created() {
    this.initRoute();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
    initRoute() {
      if (!(localStorage.getItem('user-menus'))) {
        this.logout();
        return
      }
      const menus = this.utils.getUserMenus()
      // console.log(menus)
      const routes = this.utils.deepClone(router.options.routes);
      // console.log(routes)
      //notMenus 默认拥有
      var userRoutes = [];
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].meta && routes[i].meta.notMenus) {
          userRoutes.push(routes[i])
        }
      }
      var getChildren = (resItemMenu, routesItem) => {
        if (!resItemMenu.children || !routesItem.children) return;
        const resRoute = this.utils.deepClone(routesItem);
        const menuChildren = resItemMenu.children;
        const routesChildren = routesItem.children;
        const len1 = menuChildren.length;
        const len2 = routesChildren.length;
        if (len1 <= 0) return;
        var resChildren = [];
        for (var i = 0; i < len1; i++) {
          for (var j = 0; j < len2; j++) {
            if (menuChildren[i].title == routesChildren[j].meta.title) {
              resChildren.push(routesChildren[j])
            }
          }
        }
        resRoute.children = resChildren;
        return resRoute;
      }

      var targetRoute = {};
      for (var i = 0; i < menus.length; i++) {
        // type 不为 2 才是菜单
        if (menus.type != '2') {
          for (var j = 0; j < routes.length; j++) {
            if (routes[j].meta && routes[j].meta.title == menus[i].title && !routes[j].meta.notMenus) {
              targetRoute = getChildren(menus[i], routes[j])
              if (targetRoute) userRoutes.push(targetRoute)
            }
          }
        }
      }
      // console.log(userRoutes)
      localStorage.setItem('user-userRoutes', encodeURIComponent(JSON.stringify(userRoutes)))
      var dashboardBtn = {
        "新增": false,
        "编辑": false,
        "复制": false,
        "分配用户": false,
      };
      const dashboardRoute = menus.find(item => {
        return item.title == '工作空间'
      })
      if (dashboardRoute && dashboardRoute.children) {
        for (var i = 0; i < dashboardRoute.children.length; i++) {
          dashboardBtn[dashboardRoute.children[i].title] = true;
        }
      }
      localStorage.setItem('user-dashboardBtn', encodeURIComponent(JSON.stringify(dashboardBtn)))
      this.routes = userRoutes

      // 模板管理权限
      let templateBtn = {
        "系统模板": false,
        "用户模板": false
      }
      const templateRoute = menus.find(item => {
        return item.title == '模板管理'
      })
      if (templateRoute && templateRoute.children) {
        for (var i = 0; i < templateRoute.children.length; i++) {
          templateBtn[templateRoute.children[i].title] = true;
        }
      }
      localStorage.setItem('user-templateBtn', encodeURIComponent(JSON.stringify(templateBtn)))
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue